import { render, staticRenderFns } from "./FormQuizSimplified.vue?vue&type=template&id=23671865&scoped=true"
import script from "./FormQuizSimplified.vue?vue&type=script&lang=js"
export * from "./FormQuizSimplified.vue?vue&type=script&lang=js"
import style0 from "./FormQuizSimplified.vue?vue&type=style&index=0&id=23671865&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23671865",
  null
  
)

export default component.exports